const technologies = [
    {
        id: 3,
        name: 'JavaScript ES6',
        src: ('../img/logos/js.png')
    },
    {
        id: 4,
        name: 'React JS',
        src: ('../img/logos/react.png')
    },
    {
        id: 5,
        name: 'React Hooks',
        src: ('../img/logos/hooks.png')
    },
    // {
    //     id: 7,
    //     name: 'ES6',
    //     src: ('../img/logos/es6.png')
    // },
    {
        id: 6,
        name: 'Node JS',
        src: ('../img/logos/node.png')
    },
    {
        id: 1,
        name: 'HTML 5',
        src: ('../img/logos/html.png')
    },
    {
        id: 2,
        name: 'Css 3',
        src: ('../img/logos/css.png')
    },
    {
        id: 7,
        name: 'SASS',
        src: ('../img/logos/sass.png')
    },
    {
        id: 8,
        name: 'Redux',
        src: ('../img/logos/redux.png')
    },
    {
        id: 9,
        name: 'Angular JS',
        src: ('../img/logos/angular.png')
    },
    {
        id: 13,
        name: 'Vue.js',
        src: ('../img/logos/vue.png')
    },
    // {
    //     id: 10,
    //     name: 'C#',
    //     src: ('../img/logos/c_sharp.png')
    // },
    {
        id: 11,
        name: 'MongoDB',
        src: ('../img/logos/mongodb.png')
    },
    {
        id: 12,
        name: 'SQL Server',
        src: ('../img/logos/sql.png')
    },



];
export default technologies